import baseAPI from "@/http";

const router = "api/seloDiagnosticoResposta";
import { atualUfDefinition } from "@/helpers/utils";

export const seloDiagnosticoRespostaAPI = {
  list: (municipioId) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-por-municipio/${municipioId}/${atualUfDefinition.uf}/${atualUfDefinition.isParceiro}/${atualUfDefinition.ambient}`
    ),
  atualizar: (resposta) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta`, resposta),
  delete: (respostaId) => baseAPI.delete(`${router}/${respostaId}`),
  enviarAnalise: (municipioId) =>
    baseAPI.put(`${router}/setar-enviada/${municipioId}`),
  downloadPdf: (dados) =>
    baseAPI.post(`${router}/obter-pdf-selo-diagnostico`, dados, {
      responseType: "blob",
    }),
  getRespostaPergunta: (perguntaId, municipioId) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-por-pergunta-municipio/${perguntaId}/${municipioId}?uf=${atualUfDefinition.uf}&parceiro=${atualUfDefinition.isParceiro}&ambiente=prod`
    ),
  getRespostaPerguntaTexto: (municipioId) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-text-por-pergunta-municipio/${municipioId}?uf=${atualUfDefinition.uf}&parceiro=${atualUfDefinition.isParceiro}&ambiente=${atualUfDefinition.ambient}`
    ),

  getRespostaPergunta26e27: (municipioId) =>
    baseAPI.get(
      `${router}/obter-selo-diagnostico-resposta-by-uf/?uf=${atualUfDefinition.uf}&parceiro=${atualUfDefinition.isParceiro}&municipioId=${municipioId}&ambiente=prod`
    ),
  updateRespostaPergunta26e27: (payload) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta-by-uf`, payload),
};
